export default __webpack_public_path__ + "static/media/fatos5.897ad3ed.jpg";